import Reveal from "@/components/site/Reveal";
import { useT } from "@/lib/i18n";

const HomePhilosophy = () => {
  const t = useT();
  return (
    <section className="bg-charcoal text-ivory grain" data-testid="impact-section">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid md:grid-cols-12 gap-12 md:gap-20 items-end">
          <Reveal className="md:col-span-7">
            <p className="text-[11px] tracking-[0.32em] uppercase text-terracotta mb-6">{t("home.philosophy.eyebrow")}</p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05]">
              {t("home.philosophy.title1")}<br />
              <span className="italic text-terracotta">{t("home.philosophy.title2")}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-5 text-ivory/75 text-lg leading-relaxed font-light">
            <p>{t("home.philosophy.p1")}</p>
            <p className="mt-5">{t("home.philosophy.p2")}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default HomePhilosophy;
